import { render, staticRenderFns } from "./sms-code.vue?vue&type=template&id=984a9aae&"
import script from "./sms-code.vue?vue&type=script&lang=js&"
export * from "./sms-code.vue?vue&type=script&lang=js&"
import style0 from "./sms-code.vue?vue&type=style&index=0&id=984a9aae&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/172.26.59.72+4873+vue-loader@15.10.1_6sfbhgu6kjcmlhpjwryimz4q4m/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports